import { apiClient } from './client';
import type { CustomerReport } from '../../types';

export const reportsService = {
  getByCustomerId: async (
    customerId: string,
    params?: { limit?: number; offset?: number }
  ): Promise<{ reports: CustomerReport[]; total: number }> => {
    return apiClient.get<{ reports: CustomerReport[]; total: number }>(
      `/api/v1/customers/${customerId}/reports`,
      params
    );
  },

  downloadPdf: async (customerId: string, reportId: string): Promise<Blob> => {
    return apiClient.getBlob(
      `/api/v1/customers/${customerId}/reports/${reportId}/pdf`
    );
  },

  downloadData: async (
    customerId: string,
    reportId: string
  ): Promise<Blob> => {
    return apiClient.getBlob(
      `/api/v1/customers/${customerId}/reports/${reportId}/data`
    );
  },
};
